import styled from "styled-components";
export const SupplierContentUnitStyle = styled.div``;
